import axios from "../../../axios";

export const getVersions = async (id) => {
  try {
    let { data } = await axios.get(
      `${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/bot/versions?bot_id=${id}`
    );
    return data;
  } catch (e) {
    console.log("errors", e);
  }
};
